var _rect, _rect2, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 43.5,
    height: 43.5,
    rx: 21.75,
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 43.5,
    height: 43.5,
    rx: 21.75,
    stroke: "#CBCBCB",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9582 28.7917C32.9582 29.3442 32.7387 29.8741 32.348 30.2648C31.9573 30.6555 31.4274 30.875 30.8748 30.875H12.1248C11.5723 30.875 11.0424 30.6555 10.6517 30.2648C10.261 29.8741 10.0415 29.3442 10.0415 28.7917V17.3333C10.0415 16.7808 10.261 16.2509 10.6517 15.8602C11.0424 15.4695 11.5723 15.25 12.1248 15.25H16.2915L18.3748 12.125H24.6248L26.7082 15.25H30.8748C31.4274 15.25 31.9573 15.4695 32.348 15.8602C32.7387 16.2509 32.9582 16.7808 32.9582 17.3333V28.7917Z",
    stroke: "#374151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5002 26.7083C23.8013 26.7083 25.6668 24.8429 25.6668 22.5417C25.6668 20.2405 23.8013 18.375 21.5002 18.375C19.199 18.375 17.3335 20.2405 17.3335 22.5417C17.3335 24.8429 19.199 26.7083 21.5002 26.7083Z",
    stroke: "#374151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.cece5609f6a50b7fa22be4982b9d789f.svg";
export { ForwardRef as ReactComponent };